// extracted by mini-css-extract-plugin
export var blok_content = "index-module--blok_content--9d7b8";
export var example_card = "index-module--example_card--d1b88";
export var example_card_caption = "index-module--example_card_caption--21d93";
export var example_card_pic = "index-module--example_card_pic--df2e9";
export var example_card_title = "index-module--example_card_title--5a947";
export var useful_example_container = "index-module--useful_example_container--569fb";